module.exports = __webpack_public_path__ + "img/Muito-alem-dos-muros-800x350.11566151.png";